<div class="reset-page">
  <a class="reset-back" [routerLink]="['/']">
    <svg-icon class="reset-back__icon" src="/assets/icons/chevron-left.svg"></svg-icon>
    <span>{{ 'label.ReturnToMainPage' | translate }}</span>
  </a>

  <div class="reset-card">
    <div class="reset-card__body">
      <app-spinner [isLoading]="isLoading()" [isFixedPosition]="false">
        <h1 class="reset-heading">{{ 'label.PasswordRecovery' | translate }}</h1>
        <p class="reset-subheading">{{ 'label.ForJobseeker' | translate }}</p>

        <form
          class="reset-form"
          [formGroup]="submitForm"
          [appConnectForm]="resetPasswordModel()"
          #ngForm="ngForm"
          (ngSubmit)="submitResetPasswordForm(ngForm)">
          <div class="auth-field">
            <hrra-floating-field>
              <input pInputText id="reset-email" type="email" autocomplete="email" formControlName="email" />
              <label for="reset-email">{{ 'label.Email' | translate }}&nbsp;<span class="auth-field__required">*</span></label>
            </hrra-floating-field>
            @if (submitForm.controls['email'].hasError('required') && (submitForm.controls['email'].touched || ngForm.submitted)) {
              <div class="auth-field__error">{{ 'message.MandatoryField' | translate }}</div>
            }
          </div>

          <div class="reset-captcha">
            <re-captcha formControlName="recaptcha" siteKey="{{ recaptchaSiteKey() }}"></re-captcha>
            @if ((submitForm.controls['recaptcha'].touched || ngForm.submitted) && submitForm.controls['recaptcha'].errors?.required) {
              <div class="auth-field__error">{{ 'message.MandatoryField' | translate }}</div>
            }
          </div>

          <button class="reset-submit" type="submit" (click)="resetPassword()">
            {{ 'label.PasswordRecovery' | translate }}
          </button>

          @if (userRegistrationNotFound()) {
            <div class="reset-notice reset-notice--error" role="alert">
              {{ 'message.UserRegistrationNotFound' | translate }}
            </div>
          }

          @if (isResetSuccessed()) {
            <div class="reset-notice reset-notice--success" role="status">
              {{ 'message.PasswordIsReset' | translate }}
            </div>
          }
        </form>
      </app-spinner>

      <div class="auth-switch">
        <span class="auth-switch__text">{{ 'label.DontHaveAnaccount' | translate }}</span>
        <a class="auth-switch__link" [routerLink]="['/jobseeker/register']">{{ 'label.CvRegistration' | translate }}</a>
      </div>
    </div>
  </div>
</div>
